import React from 'react';
import { useTranslate } from 'ra-core';
import { Typography, LinearProgress, makeStyles } from '@material-ui/core';
export const AccountSetupPreparingForm = props => {
    const translate = useTranslate();
    const classes = useStyles(props);
    return (React.createElement("div", { className: classes.root },
        React.createElement(Typography, { className: classes.title, variant: "body1", gutterBottom: true }, translate('apihub.account_setup.notifications.prepare')),
        React.createElement(LinearProgress, null)));
};
const useStyles = makeStyles(theme => ({
    root: {},
    title: {
        color: theme.palette.text.primary,
    },
}), {
    name: 'Layer7AccountSetupPreparingForm',
});
//# sourceMappingURL=AccountSetupPreparingForm.js.map